(() => {
  const ATTR_RE = /(r[-_ ]?terms|ez[-_ ]?terms|term|condition|agree|consent|policy)/i;
  const TEXT_RE = /(nõustun|kasutustingim|müügitingim|terms?\b|conditions?\b|agree\b|consent\b)/i;
  const observedRoots = new WeakSet();

  const important = (el, prop, value) => {
    try { el.style.setProperty(prop, value, 'important'); } catch (_) {}
  };

  function nearbyTermsText(input) {
    const label = input.closest?.('label');
    if (label && TEXT_RE.test((label.textContent || '').replace(/\s+/g, ' ').trim())) return true;

    let el = input.parentElement;
    for (let i = 0; el && i < 3; i += 1, el = el.parentElement) {
      const text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (text && text.length <= 700 && TEXT_RE.test(text)) return true;
    }
    return false;
  }

  function isTermsCheckbox(input) {
    if (!(input instanceof HTMLInputElement) || input.type !== 'checkbox') return false;

    const attrs = [
      input.id,
      input.name,
      input.className,
      input.getAttribute('aria-label'),
      input.getAttribute('data-name'),
      input.getAttribute('data-testid')
    ].filter(Boolean).join(' ');

    return ATTR_RE.test(attrs) || nearbyTermsText(input);
  }

  function paint(input) {
    if (!isTermsCheckbox(input)) return;

    input.classList.add('aniverse-terms-checkbox');

    const baseStyles = {
      '-webkit-appearance': 'none',
      'appearance': 'none',
      'width': '20px',
      'height': '20px',
      'min-width': '20px',
      'max-width': '20px',
      'flex': '0 0 20px',
      'margin': '0 8px 0 0',
      'padding': '0',
      'box-sizing': 'border-box',
      'position': 'relative',
      'display': 'inline-grid',
      'place-content': 'center',
      'vertical-align': 'middle',
      'border': '1.5px solid rgba(255, 216, 77, .92)',
      'border-radius': '6px',
      'background-image': 'none',
      'box-shadow': 'inset 0 0 0 1px rgba(255,255,255,.04), 0 1px 4px rgba(0,0,0,.34)',
      'cursor': 'pointer'
    };

    Object.entries(baseStyles).forEach(([prop, value]) => important(input, prop, value));

    const updateState = () => {
      important(input, 'background', input.checked ? '#ffd84d' : '#211e27');
      important(input, 'background-color', input.checked ? '#ffd84d' : '#211e27');
      important(input, 'border-color', input.checked ? '#ffd84d' : 'rgba(255, 216, 77, .92)');
    };

    updateState();

    if (input.dataset.aniverseTermsStyled !== 'true') {
      input.dataset.aniverseTermsStyled = 'true';
      input.addEventListener('change', () => requestAnimationFrame(updateState));
      input.addEventListener('click', () => setTimeout(updateState, 0));
    }
  }

  function scan(root) {
    if (!root) return;

    if (root instanceof HTMLInputElement && root.type === 'checkbox') paint(root);

    if (root.querySelectorAll) {
      root.querySelectorAll('input[type="checkbox"]').forEach(paint);

      root.querySelectorAll('*').forEach((el) => {
        if (el.shadowRoot) observeRoot(el.shadowRoot);
      });
    }
  }

  function observeRoot(root) {
    if (!root || observedRoots.has(root)) return;
    observedRoots.add(root);

    scan(root);

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE || node.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
            scan(node);
          }
        });
      }
    });

    observer.observe(root, { childList: true, subtree: true });
  }

  const boot = () => {
    observeRoot(document);
    [250, 750, 1500, 3000].forEach((delay) => setTimeout(() => scan(document), delay));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
